import script from "./CxInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxInput.vue?vue&type=script&setup=true&lang=ts"

import "./CxInput.vue?vue&type=style&index=0&id=eed1be96&lang=less"

const __exports__ = script;

export default __exports__